if (!window.xVariantLinkInit) {
    window.xVariantLinkInit = true;
    document.addEventListener('click', function(e) {
        const link = e.target.closest('a.link-product-variant, a.x-card-title');
        if (!link) return;
        const card = link.closest('.card-product');
        if (!card) return;
        const variantEl = card.querySelector('.current-variant');
        if (!variantEl) return;
        const variantId = variantEl.textContent.trim();
        if (!variantId) return;
        const url = new URL(link.href);
        if (url.searchParams.has('variant')) return;
        url.searchParams.set('variant', variantId);
        e.preventDefault();
        window.location.href = url.toString();
    }, true);
}